module.exports = __webpack_public_path__ + "img/voucherAdd.a083c98e.png";